import { FunctionComponent } from "react";
import { ThemeProvider as TP } from "@emotion/react";
import { /* dark, */ light } from "./schemas";

interface ProviderProps {
  children: any;
}

const ThemeProvider: FunctionComponent<ProviderProps> = ({ children }) => {
  return <TP theme={light}>{children}</TP>;
};

export default ThemeProvider;
